import { useState } from 'react'
import InfoModal from '../InfoModal/InfoModal'
import './InfoButton.css'

function InfoButton({ title, content }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <span className="info-button-wrapper">
        <button
          className="info-button"
          onClick={() => setIsModalOpen(true)}
          aria-label={`Learn more about ${title}`}
        >
          <img src="/img/Info.png" alt="Info" className="info-icon" />
        </button>
        <img src="/img/flecha.png" alt="" className="info-arrow" aria-hidden="true" />
      </span>
      <InfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
        content={content}
      />
    </>
  )
}

export default InfoButton
